import { Contact } from '@features/contacts/types/contact'
import { InvoiceFormReceiver } from '@features/invoices/types/invoiceForm/invoiceFormReceiver'

export const getInvoiceFormReceiverFromContact = (contact: Contact): InvoiceFormReceiver => {
  return {
    addressLine2: contact.addressLine2,
    cityText: contact.cityText,
    contactNo: contact.contactNo,
    countryId: contact.countryId,
    currencyId: contact.currencyId,
    ean: contact.ean,
    eInvoiceScheme: contact.eInvoiceScheme,
    email: contact.email,
    externalId: contact.externalId,
    id: contact.id,
    invoicingLanguage: contact.invoicingLanguage,
    name: contact.name,
    paymentTermsDays: contact.paymentTermsDays,
    phone: contact.phone,
    publicEntityRoutingEnabled: contact.publicEntityRoutingEnabled,
    registrationNo: contact.registrationNo,
    street: contact.street,
    type: contact.type,
    vatNo: contact.vatNo,
    zipcodeText: contact.zipcodeText,
  }
}
